import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { useAIChatData } from '../contexts/storage-contexts/AIChat';
import { useChallengeData } from '../contexts/storage-contexts/Challenge';

export const STORAGE_KEY = 'Online_Programs_AI_Chat_124';

export const useChatAPI = () => {
  const { t } = useTranslation();

  const [isPending, setIsPending] = useState(false);
  const { challengeData } = useChallengeData();
  const challengeId = challengeData?.challenge?.id;
  const {
    currentChatId,
    currentChatPair,
    // chat,
    messages,
    personaSettings,
    setCurrentChatId,
    createPersonaChat,
    requestPersonaChat,
    sendChatMessage,
    requestChatMessages,
    getPersonaPair,
    getPersonaSettings,
  } = useAIChatData();
  const personaId = currentChatPair?.personaId || null;

  const params = new URLSearchParams(window.location.search);
  const configurationIdFromQuery = params.get('configurationId') || undefined;
  const chatIdFromQuery = params.get('chatId') || undefined;

  const welcomeMessage =
    (personaSettings?.enableWelcomeMessage &&
      personaSettings?.welcomeMessage) ||
    t('aiHelper.communicationRules.welcomeMessage.defaultValue', {
      defaultValue: "Hi! I'm your study assistant. How can I help you today?",
    });

  useEffect(() => {
    const storedChatId = localStorage.getItem(`${STORAGE_KEY}–${challengeId}`);

    setIsPending(true);

    if (chatIdFromQuery || storedChatId) {
      void setCurrentChatId(chatIdFromQuery || storedChatId);
    } else {
      void createPersonaChat(
        personaId,
        welcomeMessage,
        configurationIdFromQuery,
      );
    }
  }, [
    personaId,
    chatIdFromQuery,
    configurationIdFromQuery,
    setCurrentChatId,
    createPersonaChat,
  ]);

  useEffect(() => {
    void getPersonaSettings(personaId);
  }, [personaId, getPersonaSettings]);

  useEffect(() => {
    if (currentChatId) {
      if (!chatIdFromQuery) {
        localStorage.setItem(`${STORAGE_KEY}–${challengeId}`, currentChatId);
      }

      void requestPersonaChat(currentChatId);
      void requestChatMessages(currentChatId);

      setTimeout(() => {
        setIsPending(false);
      }, 1000);
    }
  }, [
    currentChatId,
    chatIdFromQuery,
    challengeId,
    requestPersonaChat,
    requestChatMessages,
  ]);

  const initConversation = useCallback(async () => {
    setIsPending(true);
    void getPersonaPair(personaId, challengeId);
  }, [getPersonaPair, personaId, challengeId]);

  const newConversation = useCallback(() => {
    setIsPending(true);
    localStorage.removeItem(`${STORAGE_KEY}–${challengeId}`);
    void createPersonaChat(personaId, welcomeMessage, configurationIdFromQuery);
  }, [
    personaId,
    configurationIdFromQuery,
    challengeId,
    welcomeMessage,
    createPersonaChat,
  ]);

  const sendMessage = useCallback(
    (message: string) => {
      void sendChatMessage(currentChatId, message);
    },
    [currentChatId, sendChatMessage],
  );

  /*
    const { conversations } = useChatHistory({
      httpClient: httpClient as any,
      enabled: true,
    });
   */

  return {
    initConversation,
    newConversation,
    isPending,
    messages,
    sendMessage,
    personaSettings,
  };
};
